module.exports = __webpack_public_path__ + "static/tablet-preview-vnkucharka-ebe15af40a8ca9850f42e69702793c8d.png";